<template>
  <div ref="waiting">

    <div class="alert alert-yellow" v-if="showVoucherSection">
      <div class="row">
        <div class="col">
          <div class="alert alert-success" role="alert">
            <div class="input-group input-group-lg">
              <h4>
                <p class="mb-0">Total Sale: <strong>{{ sale.sale_items_sum_amount_gross | money }}</strong></p>
                <p class="mt-2 mb-0">Left To Pay: <strong>{{ sale.left_to_pay | money }}</strong></p>
                <p class="mt-2 mb-0" v-if="voucherWorth">Voucher Amount: <strong>{{ voucherWorth | money }}</strong></p>
                <p class="mt-2 mb-0" v-if="voucherWorth">After Redemption: <strong>{{ sale.left_to_pay - voucherWorth | money }}</strong></p>
              </h4>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Voucher Code"
                v-model="voucherCode">
              <div class="input-group-append">
                <button class="btn btn-orange" type="button" ref="submitVoucherCodeButton" @click="submitVoucherCode" :disabled="! voucherCode">Redeem</button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <button class="btn btn-lg btn-block btn-secondary" @click="cancelRedeeming">Cancel Redeeming</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="voucherError">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            <div class="input-group">
              <p class="mb-0">{{ voucherError }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="voucherSuccess">
        <div class="col">
          <div class="alert alert-orange" role="alert">
            <div class="input-group">
              <p class="mb-0">Voucher ready to apply to sale: {{ voucher.reference }}</p>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- showVoucherSection -->

    <div class="d-flex justify-content-end align-items-center" v-if="allowPayment">
      <div class="btn-group">
        <button
          v-if="voucherWorth"
          class="btn btn-lg btn-dark-green"
          @click="redeemVoucher">
          Use {{ voucherWorth | money }} Voucher On Sale
        </button>
        <button
          class="btn btn-lg btn-orange"
          :disabled="voucherButtonDisable"
          @click="voucherButtonClicked">
          Redeem Voucher
        </button>
        <button
          v-if="depositable"
          class="btn btn-lg btn-yellow"
          @click="takePayment(true)">
          {{ depositStatement }}
        </button>
        <button
          v-if="sale.leftToPay > 0"
          class="btn btn-lg btn-green"
          @click="takePayment">
          {{ payTheRest }}
        </button>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <h4 class="heading text-red">Your payment window will likely have ended, please go through the payment process through the website or contact the branch.</h4>
      </div>
    </div>

    <pay-handler
      ref="payComponent"
      :location="location"/>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
    defaultPerRoomDeposit: {
      type: Number,
      default: 5000,
    },
  },

  data() {
    return {
      showVoucherSection: false,
      voucherCode: null,
      voucher: null,
      voucherError: false,
      voucherSuccess: false,
      voucherButtonDisable: false,

      allowPayment: true,
    }
  },

  computed: {
    depositAmount() {
      if (this.sale.deposit_amount) {
        return this.sale.deposit_amount;
      }

      return this.sale.sale_items.filter(si => si.saleable_type == 'App\\Models\\Booking').length * this.defaultPerRoomDeposit;
    },

    payTheRest() {
      if (this.sale.leftToPay == this.sale.totalAmount) {
        return "PAY IN FULL";
      } else {
        return "PAY REMAINING";
      }
    },

    depositable() {
      if (! (this.sale.leftToPay == this.sale.totalAmount)) {
        return false;
      }

      if (this.sale.totalTransactionsAmount) {
        // there has been a payment, only allow in full
        return false;
      }

      if (this.sale.deposit_amount) {
        return true;
      }

      if (this.sale.totalAmount < (this.defaultPerRoomDeposit * 1.5)) {
        // the Sale is below £75, so not worthy the £50 deposit
        return false;
      }

      if ((this.sale.totalAmount / this.sale.sale_items.length) < (this.defaultPerRoomDeposit * 1.25)) {
        // if the average sold_for for the SaleItems are less than £65, not worth leaving a deposit
        return false;
      }

      return true;
    },

    depositStatement() {
      if (this.sale.deposit_amount) {
        return 'PAY ' + this.$money(this.depositAmount) + ' DEPOSIT';
      }

      return 'PAY ' + this.$money(this.defaultPerRoomDeposit) + ' PER ROOM DEPOSIT (' + this.$money(this.depositAmount) + ')';
    },

    voucherWorth() {
      if (this.voucher) {
        if (this.voucher.type == 'M') {
          return this.voucher.amount;
        } else if (this.voucher.type == 'O') {
          return this.location.prices.find(price => price.price_for == this.voucher.amount).offpeak
        } else {
          return this.location.prices.find(price => price.price_for == this.voucher.amount).peak
        }
      }
      return 0;
    },

  },

  methods: {
    takePayment(deposit = false) {
      this.$refs.payComponent.takeSalePayment(this.sale, deposit === true ? true : false);
    },

    voucherButtonClicked() {
      this.voucherButtonDisable = true;
      this.showVoucherSection = true;
    },

    cancelRedeeming() {
      this.voucherButtonDisable = false;
      this.showVoucherSection = false;

      this.voucherCode = null;
      this.voucher = null;
      this.voucherError = false;
      this.voucherSuccess = false;
    },

    submitVoucherCode() {
      // validation
      if (! this.voucherCode) {
        flash('No voucher code entered', 'danger');
        return false;
      }

      let request = {
        voucherCode: this.voucherCode,
      }
      this.voucherError = null;
      this.voucherSuccess = false;
      this.voucher = null;

      this.loading(true, this.$refs.waiting);

      axios.post(this.route('api.locations.vouchers.show', this.location.slug), request)
        .then((response) => {
          this.loading(false);
          // console.log('api.locations.vouchers.show');
          // console.log(response.data);

          if (response.status == 200) {
            if (response.data.has_expired) {
              flash('This voucher has expired', 'error');
              this.voucherError = 'This voucher has expired.';
              this.voucher = null;

              return false;
            }

            if (response.data.type == 'M' && response.data.amount > this.sale.left_to_pay) {
              flash('This voucher is greater than the sale', 'error');
              this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';
              this.voucher = null;

              return false;
            } else {
              //is an off-peak or peak voucher

              if (response.data.type == 'O' && this.location.prices.find(price => price.price_for == response.data.amount).offpeak > this.cart.price) {
                flash('This voucher is greater than the sale', 'error');
                this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';
                this.voucher = null;
                return false;
              }
              if (response.data.type == 'P' && this.location.prices.find(price => price.price_for == response.data.amount).peak > this.cart.price) {
                flash('This voucher is greater than the sale', 'error');
                this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';
                this.voucher = null;
                return false;
              }
            }

            this.voucher = response.data;
            this.voucherSuccess = true;

          } else {
            flash('Error fetching Voucher from code', 'error');
            console.log('submitVoucherCode', response.data);
            console.log('submitVoucherCode', response.status);
            console.log('submitVoucherCode', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error fetching Voucher from code', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('submitVoucherCode:422', error.response.data);
            } else if (error.response.status == 404) {
              let msg = 'There is no (unredeemed) Voucher with this code';
              flash(msg, 'warning');
              this.voucherError = msg;
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT

              console.log('submitVoucherCode:409', error.response.data);

              flash(error.response.data, 'error');
              this.voucherError = error.response.data;

            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('submitVoucherCode:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('submitVoucherCode:401', error.response.data);
              window.location.reload();
            } else {
              console.log('submitVoucherCode: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('submitVoucherCode: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('submitVoucherCode: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // submitVoucherCode

    redeemVoucher() {
      let voucherTransaction = {
        amount: this.voucherWorth,
        booked_by: 'W',
        cart_reference: this.voucher.reference,  // don't change this or everything will break
        from: 'C',
        transaction_reference: null,
        transaction_type_id: 15,
      }

      let request = {
        transactions: {voucherTransaction},
      };

      axios.post(this.route('api.sales.transactions.store', this.sale.hashid), request)
        .then((response) => {
          if (response.status == 200) {

            console.log('about to redirect to', response.data.customerRedirect);

            if (response.data.left_to_pay == 0) {
              window.location.href = this.route('location.payment.success', [this.location, response.data]);
            } else {
              window.location.href = response.data.customerRedirect;
            }

          } else {
            flash('Error submitting new Transactions', 'danger');
            console.log('submitNewTransactions', response.data);
            console.log('submitNewTransactions', response.status);
            console.log('submitNewTransactions', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error submitting new Transactions', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            if (error.response.status == 422) {
              console.log('submitNewTransactions: laravel validation error', error.response.data);
            }
            // else if HTTP_CONFLICT to many saleables or over lap
            else if (error.response.status == 409) {
              this.lockError = error.response.data;
            }
            // else if HTTP_FORBIDDEN on enough permissions
            else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('submitNewTransactions:401', error.response.data);
              window.location.reload();
            }
            else {
              console.log('submitNewTransactions: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('submitNewTransactions: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('submitNewTransactions: Error', error.message);
          }
          this.loading(false);
        });
    },

    paymentTimeExpired() {
      // console.log('paymentTimeExpired()');
      this.allowPayment = false;
    }
  },
}
</script>
